export default __webpack_public_path__ + "assets/location-8516c17de080608f543ccf56c7c60686.svg";